import Crud from './crud'
var crud = new Crud('feeutnk', 'phí ủy thác nhập khẩu');

const state = {
    ...crud.state,
    selected: {
        ID: 0,
        AmountFrom: 0,
        AmountTo: 0,
        FeePercent: 0,
        Cost: 0
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
